import { FUSION_URL } from '../../../apiHelper/apiRoute/fusion'
import { getFusion } from '../../../apiHelper/fusionApi'

export async function insuranceSearch({ searchString }) {
  try {
    if (searchString) {
      const insuranceSearchEndpoint = FUSION_URL.PATIENT_INSURANCE_SEARCH + searchString
      let res = await getFusion(insuranceSearchEndpoint)
      if (res?.status === 'success') {
        return res.results || []
      } else {
        console.error('Error with insurances', res?.response?.data?.detail)
      }
    }
    return []
  } catch (err) {
    console.error('Error getting insurances', err)
    return false
  }
}
